function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { Menu, MenuList, MenuButton, MenuItem, MenuLink } from '@reach/menu-button';
import ActionsArrowDown from '@strava/icons/ActionsArrowDownNormalXsmall';
import './_reach.scss';
import styles from './styles.scss';
import buttonStyles from '../Button/styles.scss'; //
// Dropdown
// --------------------

export function Dropdown(_ref) {
  var text = _ref.text,
      children = _ref.children,
      onClick = _ref.onClick,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(Menu, null, /*#__PURE__*/React.createElement(MenuButton, {
    className: "".concat(buttonStyles.btn, " ").concat(buttonStyles["default"], " ").concat(styles.btn, " ").concat(className),
    onClick: onClick
  }, text, /*#__PURE__*/React.createElement(ActionsArrowDown, {
    className: styles.icon
  })), /*#__PURE__*/React.createElement(MenuList, {
    className: "".concat(styles.list, " ").concat(className)
  }, children));
}
Dropdown.defaultProps = {
  className: null,
  onClick: function onClick() {}
};
//
// DropdownLink
// --------------------
export function DropdownLink(_ref2) {
  var as = _ref2.as,
      href = _ref2.href,
      children = _ref2.children,
      className = _ref2.className,
      otherProps = _objectWithoutProperties(_ref2, ["as", "href", "children", "className"]);

  return /*#__PURE__*/React.createElement(MenuLink, Object.assign({
    as: as,
    className: "".concat(styles.item, " ").concat(className),
    href: href
  }, otherProps), children);
}
DropdownLink.defaultProps = {
  as: 'a',
  className: null
};
//
// DropdownItem
// --------------------
export function DropdownItem(_ref3) {
  var as = _ref3.as,
      onSelect = _ref3.onSelect,
      children = _ref3.children,
      className = _ref3.className,
      otherProps = _objectWithoutProperties(_ref3, ["as", "onSelect", "children", "className"]);

  return /*#__PURE__*/React.createElement(MenuItem, Object.assign({
    as: as,
    className: "".concat(styles.item, " ").concat(className),
    onSelect: onSelect
  }, otherProps), children);
}
DropdownItem.defaultProps = {
  as: 'div',
  className: null,
  onSelect: function onSelect() {}
};